function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  --color1: #05b5f0;\n  --color2: #98dbf3;\n\n  position: relative;\n  height: 100%;\n  background-color: var(--color2);\n  ",
        "\n  > div {\n    height: 100%;\n    background-color: var(--color1);\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React, { forwardRef } from "react";
import propTypes from "prop-types";
import styled from "styled-components";
var PercentageBar = /*#__PURE__*/ forwardRef(function PercentageBar(props, ref) {
    var fraction = props.fraction, color1 = props.color1, color2 = props.color2, height = props.height, _style = props.style, rest = _objectWithoutProperties(props, [
        "fraction",
        "color1",
        "color2",
        "height",
        "style"
    ]);
    var style = _objectSpread({}, _style);
    if (color1) style["--color1"] = color1;
    if (color2) style["--color2"] = color2;
    if (height) style.height = height;
    return /*#__PURE__*/ React.createElement("div", _extends({}, rest, {
        style: style,
        ref: ref
    }), /*#__PURE__*/ React.createElement("div", {
        style: {
            width: "".concat((fraction || 0) * 100, "%")
        }
    }));
});
var StPercentageBar = styled(PercentageBar)(_templateObject(), function(props) {
    return props.$rounded && "border-radius: 999px;";
}, function(props) {
    return props.$rounded && "border-radius: 999px;";
});
PercentageBar.propTypes = {
    fraction: propTypes.number,
    height: propTypes.oneOfType([
        propTypes.number,
        propTypes.string
    ]),
    color1: propTypes.string,
    color2: propTypes.string,
    style: propTypes.shape({
        "--color1": propTypes.string,
        "--color2": propTypes.string,
        height: propTypes.oneOfType([
            propTypes.number,
            propTypes.string
        ])
    })
};
export default StPercentageBar;
